
/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Recommendation Video Component Styles
 *
 * @file RightPannel.jsx
 * @author Murhsid Ahamedh
 */

import React from 'react';
import PropTypes from 'prop-types';
import RightPannelRoot from './styles/RightPannelStyle';

const RightPannel = ({ children }) => (
  <RightPannelRoot>
    {children}
  </RightPannelRoot>
);

RightPannel.propTypes = {
  children: PropTypes.node
};

RightPannel.defaultProps = {
  children: null
};

export default RightPannel;

